export function rentalPrice(days, prices = [10, 25, 45, 125]) {
  if (!Number.isInteger(days) || days < 1 || days > 3660 || prices.length !== 4 || prices.some(price => !Number.isFinite(price) || price <= 0)) return null;
  const durations = [1, 3, 7, 30];
  const cents = prices.map(price => Math.round(price * 100));
  const totals = [0];
  for (let day = 1; day <= days; day += 1) {
    totals[day] = Math.min(...durations.map((duration, index) => cents[index] + totals[Math.max(0, day - duration)]));
  }
  return totals[days] / 100;
}

export function rentalDays(start, end) {
  const parse = value => {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return null;
    const timestamp = Date.parse(`${value}T00:00:00Z`);
    return Number.isFinite(timestamp) && new Date(timestamp).toISOString().slice(0, 10) === value ? timestamp : null;
  };
  const first = parse(start);
  const last = parse(end);
  return first === null || last === null || last < first ? null : Math.round((last - first) / 86400000) + 1;
}

function initialize(root) {
  if (root.dataset.pricingReady) return;
  const form = root.querySelector('form');
  const quantity = form?.querySelector('[name="contact[number-of-radios-needed]"]');
  const start = form?.querySelector('[data-rental-start]');
  const end = form?.querySelector('[data-rental-end]');
  const estimate = form?.querySelector('[data-rental-estimate]');
  const output = form?.querySelector('[data-rental-total]');
  const field = form?.querySelector('[data-rental-estimate-field]');
  if (![form, quantity, start, end, estimate, output, field].every(Boolean)) return;
  root.dataset.pricingReady = 'true';
  output.setAttribute('role', 'status');
  const prices = ['dailyPrice', 'eventPrice', 'weeklyPrice', 'monthlyPrice'].map(key => Number(root.dataset[key]));
  const update = () => {
    const count = Number(quantity.value);
    const days = rentalDays(start.value, end.value);
    const perRadio = rentalPrice(days, prices);
    const total = perRadio === null || !Number.isSafeInteger(count) || count < 1 ? null : Math.round(perRadio * 100) * count;
    const valid = total !== null && Number.isSafeInteger(total) && start.validity.valid && end.validity.valid;
    estimate.hidden = !valid;
    field.disabled = !valid;
    field.value = valid ? `${(total / 100).toFixed(2)}; ${count} radio(s); ${days} reserved use day(s); shipping, tax and optional accessories excluded; estimate only` : '';
    output.textContent = valid ? new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 2 }).format(total / 100) : '';
  };
  for (const input of [quantity, start, end]) {
    input.addEventListener('input', update);
    input.addEventListener('change', update);
  }
  form.addEventListener('submit', update);
  update();
}

if (typeof document !== 'undefined') {
  const initializeAll = () => document.querySelectorAll('[data-rental-page]').forEach(initialize);
  initializeAll();
  document.addEventListener('shopify:section:load', initializeAll);
}
